import React, { Component } from 'react';
import { array, bool, func, number, shape, string } from 'prop-types';
import JobTitleMatches from 'ps-components/Modules/AddJob/JobTitleMatches';
import JobTitleSearch from 'ps-components/Modules/AddJob/JobTitleSearch';
import Placeholder from 'ps-components/Placeholder/Placeholder';
import './AdHoc.scss';

const ERROR_LINE_ONE = 'Sorry, no skills available for PayScale job title match';
const ERROR_LINE_TWO = 'Search for a different job title';
const PLACEHOLDER_TEXT = 'Cannot find a PayScale job title match, please search for a different job title';

class Adhoc extends Component {
  static propTypes = {
    addJob: shape({
      jobCode: string,
      jobTitles: array,
      noJobCode: bool,
      searchLoaded: bool,
      searchLoading: bool,
      workLocationExact: string
    }),
    cancelEditJobTitle: func,
    editJobTitleMode: bool,
    handleJobClick: func,
    isEditing: bool,
    orgJobId: number,
    orgJobTitle: string,
    resetSkillsError: func,
    skills: array,
    skillsError: string,
    titleJobSearch: func
  };

  constructor(props) {
    super(props);

    this.state = {
      showJobCards: false
    };
  }

  componentDidMount() {
    const searchBox = document.getElementById('payscale__job-title-search');
    if (searchBox) {
      document.getElementById('payscale__job-title-search').focus();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { showJobCards } = this.state;
    const { addJob, showSearch, skills, skillsError } = this.props;

    if (
      (skills.length === 0 && skillsError.length > 0 && prevProps.skillsError.length === 0) ||
      (showSearch && !prevProps.showSearch)
    ) {
      this.setState({ showJobCards: false });
    }
    if (
      addJob.jobTitles !== prevProps.addJob.jobTitles &&
      !showJobCards &&
      addJob.searchLoaded &&
      !addJob.searchLoading
    ) {
      this.setState({ showJobCards: true });
    }

    if (showSearch && showSearch !== prevProps.showSearch) {
      const searchBox = document.getElementById('payscale__job-title-search');
      if (searchBox) {
        document.getElementById('payscale__job-title-search').focus();
      }
    }
  }

  componentWillUnmount() {
    this.setState({
      showJobCards: false
    });
  }

  jobSearchSection() {
    const {
      addJob,
      cancelEditJobTitle,
      isEditing,
      isInitialLoad,
      orgJobId,
      orgJobTitle,
      skills,
      skillsError,
      titleJobSearch
    } = this.props;
    const { jobCode, noJobCode, workLocationExact } = addJob;
    const showCancelButton = isEditing && skills.length === 0 && skillsError.length > 0 && !isInitialLoad;
    const populateSearchTitle = skills.length === 0 && skillsError.length > 0;

    return (
      <JobTitleSearch
        cancelEditJobTitle={cancelEditJobTitle}
        editJobTitleMode={!showCancelButton}
        jobCode={jobCode}
        noJobCode={noJobCode}
        orgJobId={orgJobId}
        orgJobTitle={populateSearchTitle ? null : orgJobTitle}
        titleJobSearch={titleJobSearch}
        workLocationExact={workLocationExact}
        feature="differentials"
      />
    );
  }

  jobTitleSection() {
    const { showJobCards } = this.state;
    const { addJob, app, handleJobClick } = this.props;
    const { jobTitles, searchLoaded, searchLoading } = addJob;

    if (searchLoaded && !searchLoading && jobTitles.length === 0) {
      return (
        <div className="card__row">
          <Placeholder
            className="pxl-text-muted skills__diff-placeholder"
            imagePath="/view/static/mp/images/empty_skills_state.svg"
            secondaryText={PLACEHOLDER_TEXT}
            showText={true}
          />
        </div>
      );
    } else if ((!searchLoaded && searchLoading) || showJobCards) {
      return (
        <div className="card__row">
          <div className="job-matches__match-container-add">
            <JobTitleMatches
              addJob={addJob}
              app={window.app}
              handleJobClick={handleJobClick}
              items={addJob.jobTitles}
              rangeChartWidth={175}
            />
          </div>
        </div>
      );
    }
  }

  renderError = () => {
    const { orgJobTitle } = this.props;

    return (
      <div className="card__row skills__results">
        <Placeholder className="skills__results-empty" imagePath="/view/static/mp/images/empty_skills_state.svg">
          <p className="pxl-text-muted">{ERROR_LINE_ONE}</p>
          <span className="skills__results-empty-job">{orgJobTitle}.</span>
          <a onClick={this.props.toggleSkillsSearch} className="skills__search-link">
            {ERROR_LINE_TWO}
          </a>
        </Placeholder>
      </div>
    );
  };

  render() {
    const { showSearch, skills, skillsError } = this.props;
    const renderError = !showSearch && skills.length === 0 && skillsError.length > 0;

    return (
      <div className="skills__search-container">
        {showSearch && <div className="card__row">{this.jobSearchSection()}</div>}
        {renderError && this.renderError()}
        {showSearch && this.jobTitleSection()}
      </div>
    );
  }
}

export default Adhoc;
